import { render, staticRenderFns } from "./centerType.vue?vue&type=template&id=2f2bca24&"
import script from "./centerType.vue?vue&type=script&lang=js&"
export * from "./centerType.vue?vue&type=script&lang=js&"
import style0 from "./centerType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports